import { useEffect, useRef, useState } from "react";

export const COIN_POOL_RESULT_DWELL_MS = 3500;

const TERMINAL_DISPLAY_STATUSES = new Set(["settling", "complete", "canceled"]);

export function useCoinPoolDisplayRound(round) {
  const [displayRound, setDisplayRound] = useState(round);
  const dwellUntilRef = useRef(0);
  const displayIdRef = useRef(round?.id ?? null);

  useEffect(() => {
    if (!round) {
      setDisplayRound(null);
      dwellUntilRef.current = 0;
      displayIdRef.current = null;
      return undefined;
    }

    const now = Date.now();
    const sameRound = String(round.id) === String(displayIdRef.current);

    if (sameRound) {
      setDisplayRound(round);
      if (TERMINAL_DISPLAY_STATUSES.has(round.status)) {
        dwellUntilRef.current = Math.max(dwellUntilRef.current, now + COIN_POOL_RESULT_DWELL_MS);
      }
      return undefined;
    }

    if (dwellUntilRef.current > now) {
      const delay = dwellUntilRef.current - now;
      const timer = window.setTimeout(() => {
        displayIdRef.current = round.id;
        setDisplayRound(round);
        dwellUntilRef.current = 0;
      }, delay);
      return () => window.clearTimeout(timer);
    }

    displayIdRef.current = round.id;
    setDisplayRound(round);
    return undefined;
  }, [round]);

  return displayRound;
}
